import { render, staticRenderFns } from "./PlanComparisonTable.vue?vue&type=template&id=7496525e&scoped=true&"
import script from "./PlanComparisonTable.vue?vue&type=script&lang=js&"
export * from "./PlanComparisonTable.vue?vue&type=script&lang=js&"
import style0 from "./PlanComparisonTable.vue?vue&type=style&index=0&id=7496525e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7496525e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
